export const AUTH_LOGIN_START = "AUTH_LOGIN_START";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAIL = "AUTH_LOGIN_FAIL";
export const AUTH_CHECK_START = "AUTH_CHECK_START";
export const AUTH_CHECK_SUCCESS = "AUTH_CHECK_SUCCESS";
export const AUTH_CHECK_FAIL = "AUTH_CHECK_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_RESET_PASSWORD_START = "AUTH_RESET_PASSWORD_START";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAIL = "AUTH_RESET_PASSWORD_FAIL";
export const AUTH_SCREEN_CHANGE = "AUTH_SCREEN_CHANGE";
export const AUTH_SEND_NEW_PASS_START = "AUTH_SEND_NEW_PASS_START";
export const AUTH_SEND_NEW_PASS_SUCCESS = "AUTH_SEND_NEW_PASS_SUCCESS";
export const AUTH_SEND_NEW_PASS_FAIL = "AUTH_SEND_NEW_PASS_FAIL";

export const DASHBOARD_SALES_START = "DASHBOARD_SALES_START";
export const DASHBOARD_SALES_SUCCESS = "DASHBOARD_SALES_SUCCESS";
export const DASHBOARD_SALES_FAIL = "DASHBOARD_SALES_FAIL";
export const DASHBOARD_INVENTORY_START = "DASHBOARD_INVENTORY_START";
export const DASHBOARD_INVENTORY_SUCCESS = "DASHBOARD_INVENTORY_SUCCESS";
export const DASHBOARD_INVENTORY_FAIL = "DASHBOARD_INVENTORY_FAIL";
export const DASHBOARD_SALES_GRAPH_START = "DASHBOARD_SALES_GRAPH_START";
export const DASHBOARD_SALES_GRAPH_SUCCESS = "DASHBOARD_SALES_GRAPH_SUCCESS";
export const DASHBOARD_SALES_GRAPH_FAIL = "DASHBOARD_SALES_GRAPH_FAIL";
export const DASHBOARD_TOP_PERFORMANCE_START =
  "DASHBOARD_TOP_PERFORMANCE_START";
export const DASHBOARD_TOP_PERFORMANCE_SUCCESS =
  "DASHBOARD_TOP_PERFORMANCE_SUCCESS";
export const DASHBOARD_TOP_PERFORMANCE_FAIL = "DASHBOARD_TOP_PERFORMANCE_FAIL";
export const DASHBOARD_PRODUCTS_SALE_START = "DASHBOARD_PRODUCTS_SALE_START";
export const DASHBOARD_PRODUCTS_SALE_SUCCESS =
  "DASHBOARD_PRODUCTS_SALE_SUCCESS";
export const DASHBOARD_PRODUCTS_SALE_FAIL = "DASHBOARD_PRODUCTS_SALE_FAIL";
export const DASHBOARD_CHART_START = "DASHBOARD_CHART_START";
export const DASHBOARD_CHART_SUCCESS = "DASHBOARD_CHART_SUCCESS";
export const DASHBOARD_CHART_FAIL = "DASHBOARD_CHART_FAIL";

export const PROFILE_GET_DETAILS_START = "PROFILE_GET_DETAILS_START";
export const PROFILE_GET_DETAILS_SUCCESS = "PROFILE_GET_DETAILS_SUCCESS";
export const PROFILE_GET_DETAILS_FAIL = "PROFILE_GET_DETAILS_FAIL";
export const PROFILE_SET_NEW_OBJ = "PROFILE_SET_NEW_OBJ";
export const PROFILE_PUT_DETAILS_START = "PROFILE_PUT_DETAILS_START";
export const PROFILE_PUT_DETAILS_SUCCESS = "PROFILE_PUT_DETAILS_SUCCESS";
export const PROFILE_PUT_DETAILS_FAIL = "PROFILE_PUT_DETAILS_FAIL";

export const IMAGE_UPLOAD_START = "IMAGE_UPLOAD_START";
export const IMAGE_UPLOAD_SUCCESS = "IMAGE_UPLOAD_SUCCESS";
export const IMAGE_UPLOAD_FAIL = "IMAGE_UPLOAD_FAIL";
export const IMAGE_MULTY_UPLOAD_START = "IMAGE_MULTY_UPLOAD_START";
export const IMAGE_MULTY_UPLOAD_SUCCESS = "IMAGE_MULTY_UPLOAD_SUCCESS";
export const IMAGE_MULTY_UPLOAD_FAIL = "IMAGE_MULTY_UPLOAD_FAIL";
export const IMAGE_DELETE_ARR = "IMAGE_DELETE_ARR";
export const IMAGE_DELETE_ARR_INDEX = "IMAGE_DELETE_ARR_INDEX";
export const IMAGE_FILL_ARRAY = "IMAGE_FILL_ARRAY";
export const IMAGE_SET_INITIAL_ARR = "IMAGE_SET_INITIAL_ARR";
export const IMAGE_CLEAR_ARR = "IMAGE_CLEAR_ARR";

export const GET_ORDERS_START = "GET_ORDERS_START";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAIL = "GET_ORDERS_FAIL";
export const UPDATE_SELECT_PER_PAGE = "UPDATE_SELECT_PER_PAGE";
export const UPDATE_SELECT_PAGE = "UPDATE_SELECT_PAGE";
export const GET_ONE_ORDER_START = "GET_ONE_ORDER_START";
export const GET_ONE_ORDER_SUCCESS = "GET_ONE_ORDER_SUCCESS";
export const GET_ONE_ORDER_FAIL = "GET_ONE_ORDER_FAIL";
export const CONFIRM_ORDER_START = "CONFIRM_ORDER_START";
export const CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS";
export const CONFIRM_ORDER_FAIL = "CONFIRM_ORDER_FAIL";
export const REJECT_PRODUCT_START = "REJECT_PRODUCT_START";
export const REJECT_PRODUCT_SUCCESS = "REJECT_PRODUCT_SUCCESS";
export const REJECT_PRODUCT_FAIL = "REJECT_PRODUCT_FAIL";

export const GET_ONE_AGG_ORDER_START = "GET_ONE_AGG_ORDER_START";
export const GET_ONE_AGG_ORDER_SUCCESS = "GET_ONE_AGG_ORDER_SUCCESS";
export const GET_ONE_AGG_ORDER_FAIL = "GET_ONE_AGG_ORDER_FAIL";
export const CONFIRM_AGG_ORDER_START = "CONFIRM_AGG_ORDER_START";
export const CONFIRM_AGG_ORDER_SUCCESS = "CONFIRM_AGG_ORDER_SUCCESS";
export const CONFIRM_AGG_ORDER_FAIL = "CONFIRM_AGG_ORDER_FAIL";
export const UPDATE_AGG_ORDER_ITEM_START = "UPDATE_AGG_ORDER_ITEM_START";
export const UPDATE_AGG_ORDER_ITEM_SUCCESS = "UPDATE_AGG_ORDER_ITEM_SUCCESS";
export const UPDATE_AGG_ORDER_ITEM_FAIL = "UPDATE_AGG_ORDER_ITEM_FAIL";

export const GET_INVENTORY_START = "GET_INVENTORY_START";
export const GET_INVENTORY_SUCCESS = "GET_INVENTORY_SUCCESS";
export const GET_INVENTORY_FAIL = "GET_INVENTORY_FAIL";
export const UPDATE_SELECT_PER_PAGE_INVENTORY =
  "UPDATE_SELECT_PER_PAGE_INVENTORY";
export const UPDATE_SELECT_PAGE_INVENTORY = "UPDATE_SELECT_PAGE_INVENTORY";

export const SET_SEARCH_STRING = "SET_SEARCH_STRING";
export const DELETE_SEARCH_STRING = "DELETE_SEARCH_STRING";

export const ADD_ITEM_START = "ADD_ITEM_START";
export const ADD_ITEM_SUCCESS = "ADD_ITEM_SUCCESS";
export const ADD_ITEM_FAIL = "ADD_ITEM_FAIL";
export const ADD_ITEM_SEARCH_START = "ADD_ITEM_SEARCH_START";
export const ADD_ITEM_SEARCH_SUCCESS = "ADD_ITEM_SEARCH_SUCCESS";
export const ADD_ITEM_SEARCH_FAIL = "ADD_ITEM_SEARCH_FAIL";
export const ADD_ITEM_SEARCH_CLEAR = "ADD_ITEM_SEARCH_CLEAR";
export const ADD_ITEM_MEASURMENT_UNIT = "ADD_ITEM_MEASURMENT_UNIT"; // Deprecated - unit is now a simple string
export const ADD_ITEM_BRAND = "ADD_ITEM_BRAND";
export const ADD_ITEM_CATEGORIES = "ADD_ITEM_CATEGORIES";
export const ADD_ITEM_ERROR = "ADD_ITEM_ERROR";
export const GET_ITEM_START = "GET_ITEM_START";
export const GET_ITEM_SUCCESS = "GET_ITEM_SUCCESS";
export const GET_ITEM_FAIL = "GET_ITEM_FAIL";
export const ITEM_DETAILS_UPDATE = "ITEM_DETAILS_UPDATE";
export const PUT_ITEM_SUCCESS = "PUT_ITEM_SUCCESS";
export const PUT_ITEM_FAIL = "PUT_ITEM_FAIL";
export const ADD_ITEM_MODAL_START = "ADD_ITEM_MODAL_START";
export const ADD_ITEM_UPDATE_NEW_ITEM = "ADD_ITEM_UPDATE_NEW_ITEM";
export const ADD_ITEM_DELETE_NEW_ITEM = "ADD_ITEM_DELETE_NEW_ITEM";
// Deprecated - Old batch management (not supported by new backend)
export const ADD_BATCH_ITEM_START = "ADD_BATCH_ITEM_START";
export const ADD_BATCH_ITEM_SUCCESS = "ADD_BATCH_ITEM_SUCCESS";
export const ADD_BATCH_ITEM_FAIL = "ADD_BATCH_ITEM_FAIL";
export const ITEM_FULL_DETAILS_UPDATE = "ITEM_FULL_DETAILS_UPDATE";
// Deprecated - Replaced by UPDATE_PRODUCT_MERCHANT
export const UPDATE_PRICE_DISCOUNT_START = "UPDATE_PRICE_DISCOUNT_START";
export const UPDATE_PRICE_DISCOUNT_SUCCESS = "UPDATE_PRICE_DISCOUNT_SUCCESS";
export const UPDATE_PRICE_DISCOUNT_FAIL = "UPDATE_PRICE_DISCOUNT_FAIL";
export const PUT_ITEM_START = "PUT_ITEM_START";

// New ProductMerchant operations (aligned with new backend)
export const GET_PRODUCT_MERCHANT_DETAILS_START = "GET_PRODUCT_MERCHANT_DETAILS_START";
export const GET_PRODUCT_MERCHANT_DETAILS_SUCCESS = "GET_PRODUCT_MERCHANT_DETAILS_SUCCESS";
export const GET_PRODUCT_MERCHANT_DETAILS_FAIL = "GET_PRODUCT_MERCHANT_DETAILS_FAIL";
export const UPDATE_PRODUCT_MERCHANT_START = "UPDATE_PRODUCT_MERCHANT_START";
export const UPDATE_PRODUCT_MERCHANT_SUCCESS = "UPDATE_PRODUCT_MERCHANT_SUCCESS";
export const UPDATE_PRODUCT_MERCHANT_FAIL = "UPDATE_PRODUCT_MERCHANT_FAIL";

export const DELETE_ITEM_START = "DELETE_ITEM_START";
export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_FAIL = "DELETE_ITEM_FAIL";

export const REPORT_START = "REPORT_START";
export const REPORT_SUCCESS = "REPORT_SUCCESS";
export const REPORT_FAIL = "REPORT_FAIL";
